<template>
    <Button
        color="carbon-400"
        :class="$style.button_override"
        :leftIcon="props.icon"
        :label="props.label"
        size="l"
        :interfaceTarget="props.interfaceTarget"
        :externalTo="props.externalTo"
        :target="props.target"
        @click="emit('click')"
    >
        <slot />
    </Button>
</template>

<script setup lang="ts">
import Button from '@/components/Buttons/Button.vue'
import { type IconNameType } from '@/components/Icon'
import { type LinkTarget } from '@/types'

type RoundButtonProps = {
    icon?: IconNameType | undefined
    label?: string | number
    interfaceTarget: string
    externalTo?: string
    target?: LinkTarget
}

const props = defineProps<RoundButtonProps>()
const emit = defineEmits(['click'])
</script>
<style module>
.button_override {
    --background-color: var(--white-08);
    --border-width: 1px;
    --border-color: var(--white-08);
    padding: 12px;
    min-width: 48px;
    flex-shrink: 0;
}
</style>
